var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompany07(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1703_202812)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3955 0.967203L10.477 0.453125L8.86021 6.48706L7.40055 1.03958L5.48196 1.55366L7.05904 7.43926L3.13092 3.51116L1.72644 4.91565L6.03509 9.22433L0.66935 7.78657L0.155273 9.70511L6.01801 11.276C5.95089 10.9865 5.91538 10.6849 5.91538 10.3749C5.91538 8.18096 7.69392 6.40243 9.88787 6.40243C12.0818 6.40243 13.8604 8.18096 13.8604 10.3749C13.8604 10.6829 13.8253 10.9827 13.759 11.2705L19.0871 12.6981L19.6012 10.7796L13.7151 9.20243L19.0812 7.76457L18.5671 5.84604L12.6813 7.42311L16.6094 3.49504L15.2049 2.09055L10.9561 6.33945L12.3955 0.967203Z",
    fill: "#FF4405"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7534 11.2928C13.5889 11.9882 13.2416 12.613 12.7651 13.1135L16.6251 16.9735L18.0296 15.5691L13.7534 11.2928Z",
    fill: "#FF4405"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7262 13.1539C12.2439 13.6464 11.6345 14.014 10.9511 14.2034L12.3557 19.4453L14.2742 18.9312L12.7262 13.1539Z",
    fill: "#FF4405"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8794 14.2225C10.5624 14.3041 10.23 14.3474 9.88753 14.3474C9.52061 14.3474 9.16529 14.2976 8.82797 14.2045L7.42212 19.4512L9.34066 19.9653L10.8794 14.2225Z",
    fill: "#FF4405"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.76014 14.1852C8.08716 13.9863 7.48858 13.6141 7.01619 13.1201L3.14668 16.9896L4.55117 18.3941L8.76014 14.1852Z",
    fill: "#FF4405"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.9843 13.0859C6.52001 12.5889 6.18181 11.9725 6.02083 11.2878L0.675293 12.7201L1.18937 14.6387L6.9843 13.0859Z",
    fill: "#FF4405"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1703_202812"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany07);
export default __webpack_public_path__ + "static/media/company-07.ea7174b8a1b18caa43475e3edd132b25.svg";
export { ForwardRef as ReactComponent };